const routes = [
    {
        path: '/main',
        name: 'main',
        component: () => import('../views/main'),
        children: [{
            path: '/home',
            name: 'home',
            component: () => import('../views/home')
        }]
    },
    {
        path: '/mmain',
        name: 'mmain',
        component: () => import('../views/mobile/main'),
        children: [
            {
                path: '/mhome',
                name: 'mhome',
                meta: {
                    isMobile: true,
                },
                component: () => import('../views/mobile/home')
            }]
    }
]
export default routes
